import { useLocation, useNavigate } from 'react-router-dom';
import { canAccess } from './staffAccess';
import { useStateContext } from '../../../contexts/ContextProvider';

export const STAFF_HOME = '/super-admin';
const CLIENT_HOME = '/dashboard';

/**
 * Mode super admin : le menu back-office remplace le menu client.
 *
 * Il est DÉRIVÉ de l'URL (ON sur `/super-admin/*`), pas stocké. Conséquences
 * voulues : une connexion atterrit sur `/dashboard`, donc repart toujours en
 * vue client (sûr en démo) ; un lien de notification vers le CRM ouvre en mode
 * back-office ; et il n'y a aucun état à réinitialiser au login, au logout ou
 * après un « se connecter en tant que ».
 */
export function useSuperAdminMode() {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const { user } = useStateContext();

    const isEligible = canAccess(user, 'crm:any');
    const isOn = isEligible && (pathname === STAFF_HOME || pathname.startsWith(`${STAFF_HOME}/`));

    // Recherche d'hôtel : l'API est gardée par `super_admin`.
    const canSearchHotels = isOn && Boolean(user?.is_super_admin);

    const setOn = (on: boolean) => navigate(on ? STAFF_HOME : CLIENT_HOME);

    return { isEligible, isOn, setOn, canSearchHotels };
}
